/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import ComponentBase from '../ComponentBase';
import CLog from '../ComponentLogger';
import { AnyFunc } from '../Types';
import KeyShortcutComponent from './KeyShortcutComponent';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

/**
 * Component used to to trigger handlers on keyboard shortcut press.
 */
@cc._decorator.ccclass
export default class ShortcutEvent extends ComponentBase
{
    public static readonly OnShortcutEvent: string = 'Shortcut.OnShortcut';

    /** Keybaord key shortcut to trigger toggle. */
    @property({ type: KeyShortcutComponent, visible: true })
    private _keyShortcutComponent: KeyShortcutComponent = null;
    public set KeyShortcutComponent(value: KeyShortcutComponent) { this._keyShortcutComponent = value; }

    @property(
    {
        type: cc.Component.EventHandler,
        tooltip: "i18n:COMPONENT.button.click_events",
        visible: true
    })
    /** @hidden */
    private _onShortcut: cc.Component.EventHandler[] = [];

    /** @hidden */
    public start(): void
    {
        super.start();
        if (!this._keyShortcutComponent)
        {
            CLog.error("No key shortcut found.", this);
            this.enabled = false;
            return;
        }

        cc.systemEvent.on(cc.SystemEvent.EventType.KEY_DOWN, this.onKeyDown, this);
    }

    public OnShortcut(fnOnShortcut: AnyFunc): void
    {
        this.node.on(ShortcutEvent.OnShortcutEvent, fnOnShortcut);
    }

    public OffShortcut(fnOffShortcut: AnyFunc): void
    {
        this.node.off(ShortcutEvent.OnShortcutEvent, fnOffShortcut);
    }

    private onKeyDown(event: cc.Event.EventCustom): void
    {
        // tslint:disable-next-line:no-string-literal
        if (!event || event['keyCode'] !== this._keyShortcutComponent.Key) { return; }

        this.node.emit(ShortcutEvent.OnShortcutEvent);
        this._onShortcut.forEach(e => e.emit([e.customEventData]));
    }
}
